import type { PaymentAttemptState } from '../types'

/**
 * Sep 24 — what /pay says when a bill's payment attempt is already under way. Every
 * one of them tells the payer not to pay again; only `unresolved` sends them to
 * support. Web shows the pair as a title and a message.
 */
export const PAYMENT_ATTEMPT_COPY: Readonly<
  Record<PaymentAttemptState, { title: string; subtitle: string }>
> = {
  processing: {
    title: 'Payment Processing',
    subtitle:
      'Your payment is processing. This bill will show as paid once it clears, so there is no need to pay again.',
  },
  received: {
    title: 'Payment Received',
    subtitle:
      'Your payment went through. It can take a moment to show as paid, so there is no need to pay again.',
  },
  unresolved: {
    title: 'We Could Not Confirm This Payment',
    subtitle:
      "We can't confirm the status of this payment. Please don't pay again. Contact support and we'll sort it out.",
  },
  in_progress: {
    title: 'Payment In Progress',
    subtitle:
      'Someone may be paying this bill right now. Try again later, and contact support if it does not clear.',
  },
  paid: {
    title: 'Already Paid',
    subtitle: 'This bill is paid. There is nothing more to pay.',
  },
}
